// @ts-nocheck
import { setResponseHeaders } from 'h3'
import joinQueryParams from '~/helpers/join-query-params'
import stripTrackingParams from '~/helpers/strip-tracking-params'

export const useProducts = () => {
  const config = useRuntimeConfig()
  const { $lang, $api } = useNuxtApp()
  const { navigation } = useNavigationStore()
  const products = ref(new Set())
  const lastProductBatch = ref([])
  const page = ref(null)
  const loading = useState('loading', () => ref(false))
  const finished = ref(false)
  const category = ref(null)
  const parent = ref(null)
  const cursor = ref(null)

  const fetchData = params => {
    const event = useRequestEvent()
    return $api('products', {
      params,
      onResponse ({ response }) {
        response.headers.forEach((value, key) => {
          if (key === 'redis-expires' && process.server) {
            setResponseHeaders(event, { Expires: value }) // use Redis-Expires as Expires value for ssr
          }
        })
      }
    })
  }

  // @TODO: PRevent duplicate code
  const load = async params => {
    if (loading.value || finished.value) { return false }
    loading.value = true
    if (params.sort) {
      params.sort_by = params.sort
      delete params.sort
    }
    const apiParams = {
      ...stripTrackingParams(joinQueryParams(params, category.value.params)),
      cursor: page.value
    }

    const { data } = await useAsyncData(`products-${JSON.stringify(apiParams)}`, () => fetchData(apiParams))

    if (data.value) {
      data.value.products.forEach(product => {
        products.value.add(product)
      })
      lastProductBatch.value = data.value.products

      if (data.value.pagination) {
        cursor.value = data.value.pagination.cursor
        finished.value = data.value.pagination.allLoaded
      }
    }
    loading.value = false
  }

  const nextPage = async params => {
    if (loading.value || finished.value) { return false }
    loading.value = true
    page.value = cursor.value

    if (params.sort) {
      params.sort_by = params.sort
      delete params.sort
    }
    const apiParams = {
      ...stripTrackingParams(joinQueryParams(params, category.value.params)),
      cursor: page.value
    }

    const data = await fetchData(apiParams)
    if (data) {
      data.products.forEach(product => {
        products.value.add(product)
      })
      lastProductBatch.value = data.products

      if (data.pagination) {
        cursor.value = data.pagination.cursor
        finished.value = data.pagination.allLoaded
      }
    }
    loading.value = false
  }

  const setCategory = ({ categorySlug, subCategorySlug }) => {
    let navCategory = navigation.find(item => {
      return Object.values(item.slugs).includes(categorySlug)
    })

    if (subCategorySlug && navCategory?.subItems && navCategory.subItems.length > 0) {
      parent.value = Object.assign({}, navCategory)

      navCategory = navCategory.subItems.find(subItem => {
        return subItem.slug === categorySlug + '/' + subCategorySlug
      })
    } else {
      parent.value = null
    }
    category.value = navCategory
  }

  const clear = () => {
    finished.value = false
    page.value = null
    cursor.value = null
    products.value.clear()
    lastProductBatch.value.length = 0
  }

  const subNavigation = computed(() => {
    if (parent.value) {
      return parent.value.subItems.map(item => {
        if (!item.slug) { return item }
        if (typeof item.images === 'undefined' || !item.images?.length) { return item }

        const image = item.images.find(image => {
          return image.type === 'product'
        })

        return Object.assign({}, item, {
          image: `${config.public.cdnURL}pictures/thumbs/${image.value}-thumbnail.webp`,
          slug: `/${$lang}/${item.slug}`
        })
      }).filter(item => {
        let returnValue = true
        if (item.validUntil) {
          returnValue = returnValue && Date.now() < Date.parse(item.validUntil)
        }
        if (item.validFrom) {
          returnValue = returnValue && Date.now() > Date.parse(item.validFrom)
        }

        return returnValue
      })
    }

    if (category.value) {
      return category.value.subItems.map(item => {
        if (!item.slug) { return item }
        if (typeof item.images === 'undefined' || !item.images?.length) { return item }

        const image = item.images.find(image => {
          return image.type === 'product'
        })
        item.image = `${config.public.cdnURL}pictures/thumbs/${image.value}-thumbnail.webp`
        return Object.assign({}, item, {
          slug: `/${$lang}/${item.slug}`
        })
      }).filter(item => {
        let returnValue = true
        if (item.validUntil) {
          returnValue = returnValue && Date.now() < Date.parse(item.validUntil)
        }
        if (item.validFrom) {
          returnValue = returnValue && Date.now() > Date.parse(item.validFrom)
        }
        return returnValue
      })
    }
    return false
  })

  const subNavigationForCollections = computed(() => {
    return subNavigation.value.map(item => {
      if (typeof item.images === 'undefined') { return item }

      const image = item.images.find(image => {
        return image.type === 'product'
      })
      item.image = `${config.public.cdnURL}pictures/hd/${image.value}.webp`
      return item
    })
  })

  const total = computed(() => products.value.size)

  return { products, lastProductBatch, page, loading, finished, total, category, parent, cursor, load, nextPage, setCategory, clear, subNavigation, subNavigationForCollections }
}
